//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import ModalActions from '../../Actions/modal';
import SessionActions from '../../Actions/session';
import MagicLinkSent from '../../SignIn/components/MagicLinkSent.react';
import Constants from '../../constants';

function _showLoginModal() {
  SessionActions.removeLoginError();
  ModalActions.closeModal(Constants.MAGIC_LINK_SENT_MODAL);
  ModalActions.openModal(Constants.LOGIN_MODAL);
}

type Props = {
  magicLinkEmail:string,
};

function MagicLinkSentModal(props:Props) {
  return (
    <MagicLinkSent magicLinkEmail={props.magicLinkEmail} showSignIn={_showLoginModal} />
  );
}

export default modal<Props>(MagicLinkSentModal, {
  name: Constants.MAGIC_LINK_SENT_MODAL,
  className: 'login-modal magiclink-sent',
});
